import React from "react";
import PlanSummary from "../components/PlanSummary";

const plan = {
  name: "Starter",
  monthlyCredits: 25,
  llmModel: "gpt-4o-mini",
  maxApps: 5,
  maxSnapshots: 20
};

function ProfilePage() {
  return (
    <div className="grid" style={{ gap: "16px" }}>
      <PlanSummary plan={plan} />

      <div className="panel">
        <h3 className="section-title">Usage this cycle</h3>
        <div className="list">
          <div className="list__item">
            <div className="flex-between">
              <span>LLM credits</span>
              <span className="badge">12 / {plan.monthlyCredits}</span>
            </div>
            <p className="muted">Credits reset monthly based on your LiteLLM plan.</p>
          </div>
          <div className="list__item">
            <div className="flex-between">
              <span>Apps</span>
              <span className="badge">2 / {plan.maxApps}</span>
            </div>
            <p className="muted">Published and draft apps count toward your allotment.</p>
          </div>
          <div className="list__item">
            <div className="flex-between">
              <span>Snapshots</span>
              <span className="badge">5 / {plan.maxSnapshots}</span>
            </div>
            <p className="muted">Snapshots keep version history of generated UIs and agents.</p>
          </div>
        </div>
      </div>

      <div className="panel">
        <h3 className="section-title">Account management</h3>
        <p className="muted" style={{ marginBottom: "12px" }}>
          Billing and plan changes are managed via Stripe. Link your publishable key and webhook secret to
          Firebase Functions to enable live upgrades.
        </p>
        <div className="flex-between">
          <div>
            <div style={{ fontWeight: 600 }}>Need more capacity?</div>
            <div className="muted">Contact us to lift credit or app limits for your workspace.</div>
          </div>
          <a className="button secondary" href="/plan">
            View plans
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
